import Component from '@glimmer/component';

import { registerDestructor } from '@ember/destroyable';
import { array, hash, uniqueId } from '@ember/helper';
import { action } from '@ember/object';
import { cached, tracked } from '@glimmer/tracking';
import { Menu } from 'ember-primitives';

import CButton from 'rise-ui/components/c-button.gjs';
import CIdentity from 'rise-ui/components/c-identity.gjs';
import { classMix } from 'rise-ui/decorators/class-mix.js';
import classMod from 'rise-ui/helpers/class-mod.js';
import concatClasses from 'rise-ui/helpers/concat-classes.js';
import hasEndSuffix from 'rise-ui/helpers/has-end-suffix.js';
import { call } from 'rise-ui/utils/function.js';

export default class DropdownButtonComponent extends Component {
  /** @type {ClassMix} */
  @classMix classMixed;

  @tracked isOpen = false;

  cleanUps = [];

  constructor() {
    super(...arguments);

    registerDestructor(this, () => {
      this.cleanUps.forEach(c => c?.());
    });
  }

  @cached get classModCfg() {
    return this.classMixed.mixClassModConfig(
      'c-dropdown-button',
      this.args.disabled, '--disabled',
    );
  }

  Myid = uniqueId();

  get side() {
    return this.args.side || 'bottom-start';
  }

  @action toggle() {
    this.isOpen = !this.isOpen;
  }

  @action cancel() {
    this.isOpen = false;
    call(this.args.onCancel);
  }

  @action submit() {
    this.isOpen = false;
    call(this.args.onSubmit);
  }

  <template>
    <Menu @offsetOptions={{8}}
      @placement={{this.side}}
      as | menu |
    >
      <CButton
        @classMix={{classMod config=this.classModCfg}}
        @type={{concatClasses "select" @type}}
        @disabled={{@disabled}}
        @title={{@title}}
        @onClick={{this.toggle}}
        {{menu.trigger}}
        ...attributes
        as | btn |
      >
        <btn.default>{{yield (hash button=(component CIdentity))}}</btn.default>
      </CButton>
      <menu.Content
        class={{concatClasses
          "floatybit"
          (classMod config=this.classModCfg suffix="__dropdown")
          (classMod
            config=this.classModCfg
            suffix="__popover"
            modifiers=(array (hasEndSuffix this.side) "--end")
          )
        }}
      >
        {{~yield (hash
          body=(component CIdentity)
          cancel=this.cancel
          submit=this.submit
        )~}}
        <div class={{classMod config=this.classModCfg suffix="__popover-arrow"}}
          {{menu.arrow}}
        />
      </menu.Content>
    </Menu>
  </template>
}
